{
  "addcategorytitle": "Add new category",
  "updatecategorytitle": "Update category",
  "addbutton": "Add",
  "updatebutton": "Update",
  "cancelbutton": "Cancel",
  "labels": {
    "locale": "Locale",
    "name": "Fallback Name (English)",
    "translation": {
      "name": "Name"
    }
  }
}
